<template>
    <BaseButton
        :type="type"
        :size="size"
        colors="bg-danger focus:ring-danger hover:bg-danger-hover active:bg-danger-active text-white"
    />
</template>

<script>
import BaseButton from '@/Components/Elements/BaseButton.vue'

export default {
    components: {
        BaseButton,
    },

    props: {
        type: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) =>
                ['xs', 'sm', 'md', 'lg', 'xl'].includes(value),
        },
    },
}
</script>
